// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24td-","colBig":"styles_colBig__rtaaG","colSmall":"styles_colSmall__4AfB1"};